export default "/assets/site/images/2.png?78f4097f13021564af50a2ce9c25398f";